import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ContactsService } from 'src/app/business-service/contacts/contacts.service';
import { DmcQuotesService } from 'src/app/business-service/dmc-quotes/dmc-quotes.service';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { ENTITY_NAMES, ORGANIZATION_TYPES, RECORD_STATUS_VALUES } from 'src/app/modules/shared/constants/api-constants';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';
import { InputValidationsService } from 'src/app/modules/shared/services/validations/input-validations.service';

@Component({
  selector: 'app-dmc-quote-itinerary-details',
  templateUrl: './dmc-quote-itinerary-details.component.html',
  styleUrls: ['./dmc-quote-itinerary-details.component.scss'],
})
export class DmcQuoteItineraryDetailsComponent implements OnInit {

  @Input() itineraryId: any;
  @Input() leadId: any;
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() assignItineraryId: EventEmitter<string> = new EventEmitter<string>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter();

  @Output() totalDaysChanges: EventEmitter<boolean> = new EventEmitter();
  @Output() totalGuestsChanges: EventEmitter<boolean> = new EventEmitter();
  @Output() destinationChanges: EventEmitter<boolean> = new EventEmitter();
  @Output() patchRecommendedItinerary: EventEmitter<any> = new EventEmitter();

  @Output() updateQuote: EventEmitter<void> = new EventEmitter();

  @Output() resetRecommended: EventEmitter<void> = new EventEmitter()

  @Input() storedFormData: any;
  @Input() editQuote: boolean = false;

  @Input() serviceBasedSections: any;

  showRecommendedItineraries: boolean = false;
  @Input() recommendedItineraryId: any;
  @Input() recommendedItineraryType: any;
  useRecommendedItinerary: boolean = false;

  recommendedDestinations: any;

  @Input() recommendedOrganizationId: any;

  selectedInventoryItineraryId: any;

  totalNoOfNights: number = 0;

  itineraryDetailsForm: FormGroup = new FormGroup({});

  recommenedItinerariesData: any = [];

  daysChanged: boolean = false;
  guestsChanged: boolean = false;
  destinationsChanged: boolean = false;

  clientId: any;

  // TODO: Use LOV from API
  dmcPackages: any = [
    { name: 'Adventure', key: 'Adventure' },
    { name: 'Heritage', key: 'Heritage' },
    { name: 'Family/Friends', key: 'Family/Friends' },
    { name: 'Honeymoon', key: 'Honeymoon' },
  ]


  constructor(
    private _fb: FormBuilder,
    private _dmcQuoteService: DmcQuotesService,
    public _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _validationService: InputValidationsService,
    private _inventoryService: InventoryService
  ) {

  }

  ngOnInit() {
    // Initialization of form
    this.itineraryDetailsForm = this._fb.group({
      itineraryName: ['', [Validators.required, this._validationService.maxLengthValidator(35)]],
      destinationDaysArray: this._fb.array([this.createDestinationItem()]),
      noOfGuests: [{}, [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      packageType: [''],
      sectionNote: ['']
    });

    this.itineraryDetailsForm.valueChanges.subscribe(() => {
      this.itineraryDetailsForm.markAsTouched();
    })

    if (this.storedFormData) {
      this.totalNoOfNights = this.storedFormData.totalDays;
      if (this.storedFormData.inventoryItineraryId) {
        this.selectedInventoryItineraryId = this.storedFormData.inventoryItineraryId;
      } else if (this.storedFormData.packageId) {
        this.selectedInventoryItineraryId = this.storedFormData.packageId;
      }

      this.itineraryDetailsForm.patchValue({
        itineraryName: this.storedFormData.itineraryName,
        destination: this.patchDestinationsDays(this.storedFormData.destination),
        startDate: this.storedFormData.startDate ? this.convertToDate(this.storedFormData.startDate) : null,
        endDate: this.storedFormData.endDate ? this.convertToDate(this.storedFormData.endDate) : null,
        noOfGuests: {
          noOfAdults: this.storedFormData.totalAdults,
          noOfChildren: this.storedFormData.totalChildrens,
          noOfInfants: this.storedFormData.totalInfants,
        },
        packageType: this.storedFormData.packageType || '',
        sectionNote: this.storedFormData.note
      })
      this.getRecommendedItinerarires();

      this.itineraryDetailsForm.markAsPristine();
      if (this.storedFormData.dataInvalid) {
        this.itineraryDetailsForm.markAllAsTouched();
      }

    }

    if (!this.leadId) {
      this.itineraryDetailsForm.removeControl('noOfGuests');
      this.itineraryDetailsForm.removeControl('startDate');
      this.itineraryDetailsForm.removeControl('endDate');
    }

    if (this.serviceBasedSections?.showRouteCraft) {
      this.showRecommendedItineraries = this.leadId;
    } else {
      this.showRecommendedItineraries = false;
    }

    // Subscribe to value change
    this.itineraryDetailsForm.get('destinationDaysArray')?.valueChanges.subscribe(value => {
      // when the destinationDaysArray changes, get recommended itineraries
      this.getRecommendedItinerarires();

      // Calculate total days based on the destinationDaysArray
      let totalDays: number = 0;
      for (let item of value) {
        totalDays += +item.days;
      }
      this.totalNoOfNights = totalDays;

      // When no of days changes, update the end date
      this.updateEndDate()
    });

    this.itineraryDetailsForm.get('startDate')?.valueChanges.subscribe(startDate => {
      this.updateEndDate();
      this.getRecommendedItinerarires();
    });

    if (this.recommendedItineraryId) {
      this.itineraryDetailsForm.markAllAsTouched();
      this.itineraryDetailsForm.markAsDirty();
    }
  }

  ngOnChanges() {
    this.ngOnInit()
  }

  ngAfterViewInit() {
  }


  today(): Date {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
  }
  convertToDate(value: any): any {
    if (!value) {
      return null;
    }
    return new Date(value);
  }

  get destinationDaysArray(): FormArray {
    return this.itineraryDetailsForm.get('destinationDaysArray') as FormArray;
  }

  createDestinationItem(): FormGroup {
    return this._fb.group({
      location: ['', Validators.required],
      days: [0, this._validationService.valueNotZeroValidator()]
    });
  }

  patchDestinationsDays(storedDestinationsData: any) {
    const destinationsArray = this.destinationDaysArray;
    storedDestinationsData.forEach((destinationDays: any, index: number) => {
      if (destinationsArray.length <= index) {
        destinationsArray.push(this.createDestinationItem());
      }
      destinationsArray.at(index).patchValue({
        location: destinationDays.location,
        days: destinationDays.days
      });
    });
  }

  addDestination() {
    this.destinationDaysArray.push(this.createDestinationItem());
  }

  removeDestination(index: number) {
    this.destinationDaysArray.removeAt(index);
    this.itineraryDetailsForm.markAsDirty();
    this.itineraryDetailsForm.markAsTouched();
  }

  private updateEndDate(): void {
    const startDate = this.itineraryDetailsForm.get('startDate')?.value;

    if (startDate && this.totalNoOfNights) {
      const startDateFormat: Date = new Date(startDate);

      const endDate = new Date(startDateFormat);
      endDate.setDate(startDateFormat.getDate() + this.totalNoOfNights);

      // const endDateFormatted = endDate.toISOString().split('T')[0];

      this.itineraryDetailsForm.get('endDate')?.setValue(endDate, { emitEvent: false });
    }
  }

  get getTotalNightsAndDays() {
    let totalNoOfNights = Number(this.totalNoOfNights);
    return `${totalNoOfNights} Nights / ${totalNoOfNights + 1} Days`
  }


  //////////////////////////
  async onSubmit(): Promise<boolean> {
    if (!this.itineraryDetailsForm.valid) {
      this.itineraryDetailsForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Fill all required fields to save", "Invalid Form");
      return false;
    }

    const formData = await this.serializeFormData(this.itineraryDetailsForm.value);

    // Handle when the itinerary is added to lead-specific
    if (this.leadId) {
      return this.handleLeadSpecificSubmission(formData);
    }
    return false;
  }

  private async handleLeadSpecificSubmission(formData: any): Promise<boolean> {
    if (this.useRecommendedItinerary) {
      this._dmcQuoteService.selectRecommendedItinerary(this.recommendedItineraryType, formData).subscribe({
        next: async (data) => {
          await this._modalPopupService.closeAllModals();
          await this._modalPopupService.openDmcQuoteForm(this.clientId, this.leadId, data.itineraryDetails?.itineraryId, null);
          this._reloadService.triggerQuotesReload();
          this._reloadService.triggerTravelPrefReload();
        },
        error: (error) => {
          console.error("Error selecting recommended itinerary", error);
        }
      })

    } else {
      if (this.editQuote) {
        this.finalizeFormSubmission(formData);
        this.emitChanges();
        this.updateQuote.emit();
        return true;
      }
      const data = await this._dmcQuoteService.addItineraryDetails(formData).toPromise();
      this._responseNotificationService.showMessage("Travel Preference Added!");
      this.finalizeFormSubmission(data);
      this.assignItineraryId.emit(data.itineraryId);
      this.emitChanges();
    }

    this._reloadService.triggerQuotesReload();
    this._reloadService.triggerTravelPrefReload();
    return true;
  }

  private emitChanges(): void {
    if (this.daysChanged) {
      this.totalDaysChanges.emit();
    }
    if (this.guestsChanged) {
      this.totalGuestsChanges.emit();
    }
    if (this.destinationsChanged) {
      this.destinationChanges.emit();
    }
  }

  private finalizeFormSubmission(data: any): void {
    this.itineraryDetailsForm.markAsPristine();
    data.dataSaved = true;
    this.storedFormData = data;
    this.storeFormData.emit(data);
  }



  ///////////////////////////

  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }


  private async serializeFormData(formData: any) {
    const serializedData = {
      itineraryName: formData.itineraryName,
      destination: formData.destinationDaysArray.filter((item: any) => item.location !== "" && item.days > 0).map((item: any) => ({
        location: item.location,
        days: item.days
      })),
      totalDays: this.totalNoOfNights,
      startDate: formData.startDate ? this._globalService.convertTripDateToString(this.convertToDate(formData.startDate)) : null,
      endDate: formData.endDate ? this._globalService.convertTripDateToString(this.convertToDate(formData.endDate)) : null,
      totalAdults: formData.noOfGuests ? formData.noOfGuests.noOfAdults : '',
      totalChildrens: formData.noOfGuests ? formData.noOfGuests.noOfChildren : '',
      totalInfants: formData.noOfGuests ? formData.noOfGuests.noOfInfants : '',
      flexibleDays: formData.flexibleDays,
      packageType: formData.packageType,
      note: formData.sectionNote,
      leadId: this.leadId,
      clientId: this.clientId,
      organizationId: this.storedFormData?.organizationId,
      status: this.storedFormData ? this.storedFormData.status : RECORD_STATUS_VALUES.DRAFT,
      id: this.storedFormData ? this.storedFormData.id : null,
      ownershipRole: this.storedFormData ? this.storedFormData.ownershipRole : null,
      ownership: this.storedFormData ? this.storedFormData.ownership : null,
      itineraryId: this.storedFormData ? this.storedFormData.itineraryId : null,
      parentItineraryId: this.storedFormData ? this.storedFormData.parentItineraryId : null,
      inventoryItineraryId: this.recommendedItineraryId ? this.recommendedItineraryId : this.storedFormData?.inventoryItineraryId || null,
      packageId: this.recommendedItineraryId ? this.recommendedItineraryId : this.storedFormData?.packageId || null,
      recommendedOrganizationId: this.recommendedOrganizationId ? this.recommendedOrganizationId : this.storedFormData?.recommendedOrganizationId || null,
      createdBy: this.storedFormData ? this.storedFormData.createdBy : null,
      section: this.storedFormData ? this.storedFormData.section : null,
      category: this.storedFormData ? this.storedFormData.category : null,
      ...(this.storedFormData && { createDate: this.storedFormData.createDate })
    };

    // Checking if days or guests changed
    if (this.storedFormData) {
      if (this.storedFormData.totalDays !== serializedData.totalDays) {
        this.daysChanged = true;
      }
      if (this.storedFormData.totalAdults + this.storedFormData.totalChildrens + this.storedFormData.totalInfants !== serializedData.totalAdults + serializedData.totalChildrens + serializedData.totalInfants) {
        this.guestsChanged = true;
      }
      if (JSON.stringify(this.storedFormData.destination) !== JSON.stringify(serializedData.destination)) {
        this.destinationsChanged = true;
      }
    }

    // Checking if user changed destination to use recommended itinerary
    if (this.recommendedItineraryId) {
      if (JSON.stringify(this.recommendedDestinations) == JSON.stringify(serializedData.destination)) {
        this.useRecommendedItinerary = true;
      } else {
        serializedData.inventoryItineraryId = null;
        serializedData.packageId = null;
        serializedData.recommendedOrganizationId = null;
      }
    }

    return serializedData;
  }


  // Recommended itinerary

  getRecommendedItinerarires() {
    if (this.showRecommendedItineraries) {
      let data = {
        leadId: this.leadId,
        destination: this.itineraryDetailsForm.get("destinationDaysArray")?.value
          .filter((item: any) => item.location !== "" && item.days > 0)
          .map((item: any) => ({
            location: item.location,
            days: item.days
          })),
        startDate: this.itineraryDetailsForm.get('startDate')?.value ? this._globalService.convertTripDateToString(this.convertToDate(this.itineraryDetailsForm.get('startDate')?.value)) : null,
        endDate: this.itineraryDetailsForm.get('endDate')?.value ? this._globalService.convertTripDateToString(this.convertToDate(this.itineraryDetailsForm.get('endDate')?.value)) : null,
      }

      if (data.destination.length > 0) {
        this._inventoryService.getRecommendedItineraries(data, ORGANIZATION_TYPES.DMC).subscribe((data) => {
          this.recommenedItinerariesData = data;
        })
      }
    }
  }

  getDestinationsArray(destinations: any[]): string {
    if (!destinations) {
      return '';
    }
    let destinationString = destinations.map((item: any) => this._globalService.getFirstItemOfString(item.location)).join(', ');
    return this._globalService.trimString(destinationString, 10);
  }

  async openInventoryItinerary(itinerary: any) {
    const { itineraryId, type, organizationId } = itinerary;

    const recommendedItinerary = {
      recommendedItineraryId: itineraryId,
      recommendedItineraryType: type === "Itinerary" ? ENTITY_NAMES.INVENTORY_ITINERARY : ENTITY_NAMES.DMC_PACKAGE,
      recommendedOrganizationId: organizationId
    };

    const modalData = type === "Itinerary"
      ? await this._modalPopupService.openInventoryItineraryView(itineraryId, this.leadId, this.clientId)
      : await this._modalPopupService.openDmcPackageReview(itineraryId, this.leadId, organizationId);

    if (modalData?.createQuote) {
      if (this.storedFormData) {
        if (await this._globalService.confirmActionPopup("This action will delete the current data and replace it with new data. Do you want to continue?", "Confirm", "Yes")) {
          await this.selectRecommendedItinerary(recommendedItinerary);
        }
      } else {
        await this.selectRecommendedItinerary(recommendedItinerary);
      }
    }
  }

  async createQuote(itinerary: any) {
    const { itineraryId: recommendedItineraryId, type: recommendedItineraryType, organizationId: recommendedOrganizationId } = itinerary;

    const recommendedItinerary = {
      recommendedItineraryId,
      recommendedItineraryType: recommendedItineraryType === "Itinerary" ? ENTITY_NAMES.INVENTORY_ITINERARY : ENTITY_NAMES.DMC_PACKAGE,
      recommendedOrganizationId
    };

    if (this.storedFormData) {
      if (await this._globalService.confirmActionPopup("This action will delete the current data and replace it with new data. Do you want to continue?", "Confirm", "Yes")) {
        await this.selectRecommendedItinerary(recommendedItinerary);
      }
    } else {
      await this.selectRecommendedItinerary(recommendedItinerary);
    }
  }

  async selectRecommendedItinerary(recommendedItinerary: any) {
    this.itineraryDetailsForm.markAsTouched();
    this.itineraryDetailsForm.markAsDirty();
    this.selectedInventoryItineraryId = recommendedItinerary.recommendedItineraryId;
    this.recommendedItineraryId = recommendedItinerary.recommendedItineraryId;
    this.recommendedItineraryType = recommendedItinerary.recommendedItineraryType;
    this.recommendedOrganizationId = recommendedItinerary.recommendedOrganizationId;

    let itineraryDetails: any = await this.serializeFormData(this.itineraryDetailsForm.value);
    this.recommendedDestinations = itineraryDetails.destination;
  }


  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      if (this.useRecommendedItinerary) {
        return;
      }
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.itineraryDetailsForm.dirty || this.itineraryDetailsForm.invalid) && this.itineraryDetailsForm.touched;
  }
}
